import React from 'react';
import Button from '../Button/Button';
import ServerCardStatus from '../ServerCardStatus/ServerCardStatus';
import { format } from 'date-fns';
import { Percentage } from '../../../api/dtos/application/Percentage';

interface ServerCardProps {
    game: string;
    percentage: Percentage;
    lastUpdate: string;
}

const ServerCard: React.FC<ServerCardProps> = ({ game, percentage, lastUpdate }) => {
    const [isActive, setIsActive] = React.useState(false);
    function handleClick() {
        setIsActive(!isActive);
    }
    const percentageText = [
        percentage.online > 0 ? `${percentage.online}% servers are functional` : '',
        percentage.maintenance > 0 ? `${percentage.maintenance}% servers are under maintenance` : '',
        percentage.offline > 0 ? `${percentage.offline}% servers are stopped` : ''
    ]
        .filter(item => item !== '')
        .join(', ');

    return (
        <div className={`server_card ${isActive ? 'active' : ''}`}>
            <div className='server_card_background'>
                <div className='server_card_content'>
                    <h3 className='server_card_title'>{game}</h3>
                    <ServerCardStatus percentage={percentage} />
                </div>
                {!isActive && (
                    <Button text='View Details' onClick={handleClick} />
                )}
                {isActive && (
                    <>
                        <div className='server_card_details'>
                            <p>{percentageText}</p>
                            <p>Last update: {format(new Date(lastUpdate), "MMMM d, yyyy 'at' h:mm a")}</p>
                            <p>Do you want more information ? Send us a message <a href="#contact_form">HERE</a></p>
                        </div>
                        <Button text='Close' onClick={handleClick} />
                    </>
                )}
            </div>
        </div>
    );
}

export default ServerCard;
